import { render, staticRenderFns } from "./Mens.vue?vue&type=template&id=4cdddf46"
import script from "./Mens.vue?vue&type=script&lang=js"
export * from "./Mens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports